export type ChecklistDownload = {
  id: string;
  title: string;
  description: string;
  cta: string;
  /** Public URL of the approved PDF download. */
  href: string | null;
  fileName: string;
};

export const CHECKLIST_BENEFITS: string[] = [
  '10 essential questions to ask before booking.',
  'Seven warning signs worth recognising.',
  'How to compare supplier quotations.',
  'Three supplier comparison worksheets.',
  'Digital fillable and printer-friendly PDF versions.',
];

export const CHECKLIST_DOWNLOADS: ChecklistDownload[] = [
  {
    id: 'digital-fillable',
    title: 'Digital Fillable Checklist',
    description: 'Complete the supplier worksheets on your phone, tablet or computer.',
    cta: 'Download digital fillable checklist',
    href: 'https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/64c80cfd-ea50-400e-b036-8673786f7535_KOR38-Event-Supplier-Checklist-Mobile-Fillable-v2.pdf',
    fileName: 'kor38-event-supplier-checklist-digital-fillable.pdf',
  },
  {
    id: 'printer-friendly',
    title: 'Printer-Friendly Checklist',
    description: 'Print the guide and complete the worksheets by hand.',
    cta: 'Download printer-friendly checklist',
    href: 'https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/97ad1cbf-f581-4847-ac6e-2b67ea5d9499_KOR38-Event-Supplier-Checklist-Print-Friendly-v2.pdf',
    fileName: 'kor38-event-supplier-checklist-printer-friendly.pdf',
  },
];